import React, { useContext } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useResponsiveConfig } from '../../../hooks/responsiveConfigSwap';
import { TopicsNavigatorBar } from '../../navigation/topicsNavigatorBar/topicsNavigatorBar';
import { Notifications } from '../../notifications/notifications';
import { AccountDetails } from '../../accountDetails/accountDetails';
import { VetDetails } from '../../vetDetails/vetDetails';
import { SLICES } from '../../../constants/slices';
import { ProfileSectionsMap } from '../../../constants/profileSectionsMap';
import { TopicsPropType } from '../../../propTypes/faqs';
import { useGetPetInfoQuery } from '../../../data/policy';
import { BrandContext } from '../../../contextProviders/brandContext';
import { AUTHENTICATION_TYPES } from '../../../constants/constants';
import './myProfileSection.scss';
import Loading from '../../shared/Loading/Loading';
import { FeatureFlagContext } from '../../../contextProviders/featureFlagContext';

export const MyProfileSection = ({ activeTopic = 'accountDetails' }) => {
  const location = useLocation();
  const urlParams = location.search;
  const { authDetails } = useSelector((state) => state?.[SLICES.AUTHENTICATION]);
  const { auth0AccessToken } = authDetails;
  // Using the RTK query hook for getting pet info (only triggered when token is available)
  const { data: petDetails, isLoading: petDetailsLoading } = useGetPetInfoQuery(auth0AccessToken, {
    skip: !auth0AccessToken
  });
  const { cspConfiguration } = useContext(FeatureFlagContext);
  const isNotificationPreferencesEnabled = cspConfiguration?.IsNotificationPreferencesEnabled;
  const { authenticationType } =
    useContext(BrandContext).activeBrandContext.cspConfiguration.auth0Config[process.env.REACT_APP_ENV];
  const isSsoAuthentication = authenticationType === AUTHENTICATION_TYPES.SSO;

  const policyId = new URLSearchParams(urlParams).get('policyId');

  const navLayout = useResponsiveConfig({
    configDefinition: {
      default: {},
      699: {
        layout: 'vertical'
      }
    }
  });

  const topicLayout = useResponsiveConfig({
    configDefinition: {
      default: {
        className: 'myProfileSection'
      },
      1100: {
        className: 'myProfileSection horizontal'
      },
      720: {
        className: 'myProfileSection vertical'
      }
    }
  });

  const topicDefinition = ProfileSectionsMap()[activeTopic];

  const { heading, title, description } = topicDefinition;

  const topics = Object.values(ProfileSectionsMap(isNotificationPreferencesEnabled, isSsoAuthentication)).filter(
    (section) => !section.hideItem
  );

  if (!petDetails) {
    return <Loading />;
  }

  return (
    <div
      className="myProfileSection"
      {...topicLayout}
    >
      <TopicsNavigatorBar
        activeTopic={activeTopic}
        topics={topics}
        {...navLayout}
      />
      <main aria-label="My Profile Section">
        <h1 className="mainPageHeader">My profile </h1>
        <h2>{title || heading}</h2>
        {description && <p>{description}</p>}

        <section>
          {activeTopic === 'accountDetails' &&
            (petDetailsLoading ? <Loading /> : <AccountDetails petDetails={petDetails} />)}

          {activeTopic === 'vetDetails' && (
            <VetDetails
              {...{
                isProfileView: true,
                petDetails,
                activePolicyNumber: policyId
              }}
            />
          )}

          {activeTopic === 'notificationPreferences' && <Notifications petDetails={petDetails} />}
        </section>
      </main>
    </div>
  );
};

MyProfileSection.propTypes = {
  activeTopic: TopicsPropType
};
